import React, {useState} from 'react'
import db from "../firebase";
import emailjs from 'emailjs-com'
import { useParams } from "react-router-dom";


function Approval() {
    
    // const [slug, setSlug] = useState('')
    const [access, setAccess] = useState('')
    const {code} = useParams()

    const handleApprove = async (e) => {
        e.preventDefault()
        let querySec = await db.collection('security').where("id", "==", 'sec')
        querySec.onSnapshot(async (data) => {
            let finalData = data.docs[0].data();
            if(finalData.accessCode === access){
                db.collection("data")
                .where("code", "==", code)
                .get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(document) {
                    document.ref.update({approved: true });
                    const data = document.data()
                    console.log(data.name);
                    const param = {
                        name: data.name,
                        email: data.email,
                        date: data.date,
                        message: data.description,
                        condition: 'Approved'
                    };
                     
                    emailjs.send('gmail', 'client', param, 'user_OW7gDyw6n0XsG4q53E3Nb')
                        .then(function(response) {
                           console.log('SUCCESS!', response.status, response.text);
                        }, function(error) {
                           console.log('FAILED...', error);
                        });
                     
                    });
                    alert('The appointment has been issued')
                });
            }else{
                alert('You are not authorized to perform this action')
                
            }
        })
        
    }
    const handleDecline = async (e) => {
        e.preventDefault()
        let querySec = await db.collection('security').where("id", "==", 'sec')
        querySec.onSnapshot(async (data) => {
            let finalData = data.docs[0].data();
            if(finalData.accessCode === access){
                db.collection("data")
                .where("code", "==", code)
                .get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(document) {
                        const data = document.data()

                        const verify = window.confirm('Are you sure? This will delete the data from the database?');
                        if(!verify){
                            window.alert('Action taken back')
                        }else{
                            const param = {
                                name: data.name,
                                email: data.email,
                                date: data.date,
                                message: data.description,
                                condition: 'Declined'
                            };
                             
                            emailjs.send('gmail', 'client', param, 'user_OW7gDyw6n0XsG4q53E3Nb')
                                .then(function(response) {
                                   console.log('SUCCESS!', response.status, response.text);
                                }, function(error) {
                                   console.log('FAILED...', error);
                                });
                            document.ref.delete()
                            alert('Appointment has been declined')
                        }
                    });
                });
            }else{
                alert('You are not authorized to perform this action')
                
            }
        })
        
    }
    return (
        <div className="mt-4 container">
        <h1 className="text-danger">Note: Click buttons only one time, it will take few seconds to process your request</h1>
            <form className="form-group">
            {/* <input type="text" placeholder="Enter Appointment Code" className="form-control mt-2" value={slug} onChange={e => setSlug(e.target.value)} required/> */}
                <input type="text" placeholder="Enter Access Token" className="form-control mt-2" value={access} onChange={e => setAccess(e.target.value)} required/>
                <br />
                <input type="button" className="btn btn-success" value="Accept"onClick={handleApprove}/>
                <input type="button" className="btn btn-danger" value="Decline" onClick={handleDecline}/>
            </form>
        </div>
    )
}

export default Approval